export const errors = {
    required: 'Required',
    minLength: 'Please add number > 0',
    invalid: 'Sorry, that\'s an invalid entry'
};
